import { all, spawn, fork, call } from "redux-saga/effects";
import { watchFetchCompetitors } from "./features/sagas/competitorsSaga";
import { watchfetchBusinessUnitAccDetail } from "./features/sagas/businessUnitAccDetailsSaga";
import { watchFetchQuestionsPrompterData } from "./features/sagas/questionsPrompterDataSaga";
import { watchFetchSelfFinancials } from "./features/sagas/selfFinancialSaga";
import { watchFetchDocuments } from "./features/sagas/documentsSaga";
import { watchFetchTechlandscape } from "./features/sagas/techLandscapeSaga";
import { watchFetchKeyTechnologies } from "./features/sagas/keyTechnologySaga";
import { watchFetchAccBuNudgeData } from "./features/sagas/accountBuNudgesSaga";
import { watchFetchGrowthOpportunitiesByAccountAndClient } from "./features/sagas/growthOpportunitiesByAccountAndClientSaga";
import { watchFetchAccountContactData } from "./features/sagas/accountContactsSaga";
import { watchFetchEvents } from "./features/sagas/eventsSaga";
import { watchFetchNewProject } from "./features/sagas/newProjectsSaga";
import { watchFetchcompCompetitors } from "./features/sagas/companyCompareSaga";
import { watchfetchCompBuFinancial } from "./features/sagas/companyBuFinancialsSaga";
import { watchFetchClientNudgeData } from "./features/sagas/clientNudgeSaga";
import { watchFetchRevenueAnalysis } from "./features/sagas/fetchRevenueAnalysisSaga";
import { watchFetchGeoWiseRevenueAnalysis } from "./features/sagas/fetchGeoWiseRevenueAnalysisSaga";
import { watchFetchAccountDetails, watchFetchAccountInfo } from "./features/sagas/accountsSaga";
import { watchfetchCompFinancial } from "./features/sagas/companyFinancialsSaga";
import { watchFetchSegments } from "./features/sagas/segmentsSaga";
import { watchFetchKeyConversation } from "./features/sagas/keyConversationSaga";
import { watchClosureSubmission } from "./features/sagas/closureAgentSaga";
import { watchChampionSaga } from "./features/sagas/championAgentSaga";
import { watchRenewalRequests } from "./features/sagas/renewalAgentSaga";
import watchDeliveryExcellence from "./features/sagas/deliveryExcellenceSaga";
import { watchGetLiveAccountsSaga } from "./features/sagas/fetchLiveAccountsSaga";
import { watchFetchDynamicTabs } from "./features/sagas/dynamicTabsSaga";
import { watchDemoRequestSubmission } from "./features/sagas/demoRequestSaga";
import { watchOpportunitiesData } from "./features/sagas/opportunities/opportunitiesSaga";
import { watchBattleCardData } from "./features/sagas/opportunities/battleCardSaga";
import { watchNewsData } from "./features/sagas/opportunities/newsSaga";
import { watchBusinessCaseData } from "./features/sagas/opportunities/businessCaseSaga";
import { watchContactCardData } from "./features/sagas/opportunities/contactCardSaga";
import { watchValueSellingCardData } from "./features/sagas/opportunities/valueSellingCardSaga";
import { watchNextStepCardData } from "./features/sagas/opportunities/nextStepCardSaga";
import { watchConvertToWinSaga } from "./features/sagas/opportunities/convertToWinSaga";
import { watchWinOpportunitiesSaga } from "./features/sagas/opportunities/winOpportunitiesSaga";
import { watchCreateDealSaga } from "./features/sagas/opportunities/increaseDealSizeSaga.js/createDealSaga";
import { watchListDealsSaga } from "./features/sagas/opportunities/increaseDealSizeSaga.js/listDealsSaga";
import { watchSpotContactsSaga } from "./features/sagas/targetedReachout/spotOpportunitiesSaga";
import { watchspotContactOppMapSaga } from "./features/sagas/targetedReachout/spotContactOppMapSaga";
import { watchIncreaseDealSizeCardData } from "./features/sagas/opportunities/increaseDealSizeCardSaga";
import { watchglobalMemSaga, watchListGlobalMemDocsSaga, watchListGlobalMemSaga } from "./features/sagas/memory/globalMemorySaga";
import { watchNudgesNewSubmission } from "./features/sagas/nudgesNewSaga";
import { watchMeetingPrepsSaga } from "./features/sagas/meetingPreps/meetingPrepsSaga";
import { watchBattleCardMpData } from "./features/sagas/meetingPreps/battleCardSaga";
import { watchNextStepsMpData } from "./features/sagas/meetingPreps/nextStepsMpCardSaga";
import {spotContactBCReducer} from "./features/reducers/targetedReachoutReducers/spotContactBattleCardReducer";
import { watchspotContactBCSaga, watchspotContactPsycoSaga } from "./features/sagas/targetedReachout/spotContactBattleCardSaga";
import { watchpitchWoData } from "./features/sagas/opportunities/pitchCardWoSaga";
import { watchMeetingPrepPromptersCardData } from "./features/sagas/meetingPreps/promptersCardSaga";
import { watchAutoNurtureSaga } from "./features/sagas/autoNurture/autoNurtureSaga";
import { watchGlobalAccountsSaga } from "./features/sagas/targetedReachout/globalAccountSaga";

export default function* rootSaga() {
  const longLivedSagas = []; // Persistent tasks
  const shortLivedSagas = [
    watchFetchCompetitors,
    watchfetchBusinessUnitAccDetail,
    watchFetchQuestionsPrompterData,
    watchFetchSelfFinancials,
    watchFetchDocuments,
    watchFetchTechlandscape,
    watchFetchKeyTechnologies,
    watchFetchAccBuNudgeData,
    watchFetchGrowthOpportunitiesByAccountAndClient,
    watchFetchAccountContactData,
    watchFetchEvents,
    watchFetchNewProject,
    watchFetchcompCompetitors,
    watchfetchCompBuFinancial,
    watchFetchClientNudgeData,
    watchFetchRevenueAnalysis,
    watchFetchGeoWiseRevenueAnalysis,
    watchFetchAccountInfo,
    watchFetchAccountDetails,
    watchfetchCompFinancial,
    watchFetchSegments,
    watchFetchKeyConversation,
    watchClosureSubmission,
    watchChampionSaga,
    watchRenewalRequests,
    watchDeliveryExcellence,
    watchGetLiveAccountsSaga,
    watchFetchDynamicTabs,
    watchDemoRequestSubmission,
    watchOpportunitiesData,
    watchBattleCardData,
    watchNewsData,
    watchBusinessCaseData,
    watchContactCardData,
    watchValueSellingCardData,
    watchNextStepCardData,
    watchConvertToWinSaga,
    watchWinOpportunitiesSaga,
    watchCreateDealSaga,
    watchListDealsSaga,
    watchSpotContactsSaga,
    watchspotContactOppMapSaga,
    watchIncreaseDealSizeCardData,
    watchglobalMemSaga,
    watchListGlobalMemSaga,
    watchListGlobalMemDocsSaga,
    watchNudgesNewSubmission,
    watchMeetingPrepsSaga,
    watchBattleCardMpData,
    watchNextStepsMpData,
    spotContactBCReducer,
    watchspotContactBCSaga,
    watchpitchWoData,
    watchMeetingPrepPromptersCardData,
    watchspotContactPsycoSaga,
    watchAutoNurtureSaga,
    watchGlobalAccountsSaga
  ]; // Page-specific API calls

  yield all([
    // Handle long-lived sagas (auto-restart mechanism)
    ...longLivedSagas?.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break; // Exit loop if saga completes successfully
          } catch (error) {
            console.error(`Error in ${saga.name}, restarting...`, error);
          }
        }
      })
    ),

    // Handle short-lived sagas (cancelled when rootSaga stops)
    ...shortLivedSagas.map(fork),
  ]);
}
